import { GetDraftUserPolicies_draftUserPolicies } from '../../../../../operation-result-types';
import { ProductRenters } from '../../../Constants/Products';
import { PolicyFinder } from '../../QuoteScreen/utils/PolicyFinder';

export const findRentalPolicy: PolicyFinder = (
  draftUserPolicies: GetDraftUserPolicies_draftUserPolicies[] = []
) => draftUserPolicies.find((policy) => policy.product?.id === ProductRenters);
